import { ContentArticle } from '../types';
import banner from '../assets/release.jpg';
import { Author } from '../authors/trey';

const body = (<div dangerouslySetInnerHTML={{ __html: `<p>Performance and polish was the word of the day, or the sprint, if you know some Agile terminology. We went deep on video capture,
WebRTC settings, and CPU/GPU utilization.</p>
<p>Ideally, you'll never notice it, but our WebRTC settings adjust now to fix quality issues during a Playcast. If we detect a bad connection,
we can downgrade aspects of the streaming video, like framerate or resolution. If the connection improves, we can upgrade, too. We also
now take into consideration the player's device size so we aren't sending 1080p resolution video to your iPhone mini.</p>
<p>Check out all the specific changes in this release. You don't really need to read this, just download it and get started.</p>
<ul>
<li>1080p Streaming Resolution: Now available for improved visual quality during streaming.</li>
<li>CPU Performance Reservation: Playcast now allocates CPU resources to maintain smooth gameplay performance, especially during intensive gaming.</li>
<li>Adjusted streaming settings to provide a more stable framerate across various conditions.</li>
<li>Improved capture rates for smoother streaming experiences.</li>
<li>Adaptive framerate and V-Sync settings on compatible NVIDIA and AMD graphics cards to ensure optimal streaming quality while Playcast is active.</li>
<li>Increased the speed of message capture in the host app for a more responsive experience.</li>
<li>Enhanced desktop surfing performance for a seamless user experience.</li>
<li>Fixed an issue causing streams to crash on Firefox clients.</li>
<li>Resolved several visual inconsistencies across the app for a more cohesive look and feel.</li>
<li>Fixed slow connection issues by refining connection logic.</li>
<li>Addressed sensitivity issues with WebRTC quality settings.</li>
<li>Corrected issues with SMS and email limits not registering correctly.</li>
<li>Fixed a performance issue affecting AMD graphics cards.</li>
</ul>
` }} className="article" />);

export const Release1x1x0: ContentArticle = {
  title: `Release Notes: v1.1.0`,
  slug: `release-1-1-0`,
  published: `2024-10-31`,
  author: Author,
  banner: banner,
  summary: `It's all about performance! Plus some polish. But mostly performance, especially when it comes to the video stream.`,
  body: body,
};
